export const EmpCardSkeleton = () => {
    return (
      <div className="bg-[#FFFFFF] p-6 shadow-[0_4px_12px_-5px_rgba(0,0,0,0.4)] w-full max-w-sm rounded-2xl font-[sans-serif] animate-pulse">
        <div className="flex justify-end mb-2">
          <div className="w-6 h-6 bg-gray-300 rounded-full" />
        </div>
  
        <div className="flex flex-col items-center space-y-4">
          <div className="w-28 h-28 rounded-full bg-gray-300" />
          <div className="w-24 h-4 bg-gray-300 rounded" />
          <div className="w-16 h-3 bg-gray-200 rounded" />
        </div>
  
        <div className="bg-[#F2F7FA] border-gray-200 border-2 p-4 rounded-md space-y-3 mt-6">
          {[1, 2, 3, 4, 5].map((_, i) => (
            <div key={i} className="flex items-center space-x-2">
              <div className="w-6 h-6 bg-gray-300 rounded" />
              <div className="w-32 h-3 bg-gray-300 rounded" />
            </div>
          ))}
        </div>
      </div>
    );
  };
  